// @flow

// Roles as returned by the authorisation service catalogue endpoint
// (`GET /api/v1/roles`). The endpoint applies the `clientRoles` scope
// server-side, so every role reaching the webclient is already filtered to
// `auraAdminOnly: false` and `clientAvailable: true`.
export type catalogueRoleT = {
  id: number,
  name: string,
  auraAdminOnly: boolean,
  clientAvailable: boolean,
  defaultRole: boolean,
  clientFriendlyRoleName: ?string,
  clientFriendlyDescription: ?string,
  createdAt: string,
  updatedAt: string,
};

export type CatalogueStatus = 'loading' | 'ready' | 'error';

export type RolesCatalogueT = {
  status: CatalogueStatus,
  roles: catalogueRoleT[],
  defaultRoleIds: number[],
};

// Display helpers shared by the catalogue hook, the role picker and the
// degraded-mode rendering, so label/description derivation lives in one
// place. The description deliberately falls back to the empty string rather
// than the internal name, which would only repeat the label.
export const roleLabel = (role: Object): string =>
  role.clientFriendlyRoleName || role.name || '';

export const roleDescription = (role: Object): string =>
  role.clientFriendlyDescription || '';
